var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckboxField(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4.75C2 3.23122 3.23122 2 4.75 2H15.25C16.7688 2 18 3.23122 18 4.75V15.25C18 16.7688 16.7688 18 15.25 18H4.75C3.23122 18 2 16.7688 2 15.25V4.75ZM4.75 3.5C4.05964 3.5 3.5 4.05964 3.5 4.75V15.25C3.5 15.9404 4.05964 16.5 4.75 16.5H15.25C15.9404 16.5 16.5 15.9404 16.5 15.25V4.75C16.5 4.05964 15.9404 3.5 15.25 3.5H4.75ZM14.0014 6.94227C14.3095 7.21921 14.3347 7.69342 14.0577 8.00144L9.33203 13.2576C9.18491 13.4246 9.00208 13.5506 8.80389 13.633C8.60377 13.7163 8.38827 13.755 8.17408 13.7495C7.95989 13.7439 7.74633 13.694 7.55041 13.5996C7.35763 13.5067 7.18255 13.3709 7.04563 13.1959L5.41701 11.1836C5.15643 10.8616 5.20619 10.3894 5.52817 10.1288C5.85014 9.86818 6.3224 9.91794 6.58299 10.2399L8.20965 12.2498C8.21073 12.2499 8.21188 12.2499 8.21308 12.25C8.21601 12.2501 8.21876 12.2499 8.22121 12.2496L12.9423 6.99856C13.2192 6.69054 13.6934 6.66534 14.0014 6.94227Z",
    fill: "#676879"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxField);
export default __webpack_public_path__ + "static/media/checkbox-field.011f74de.svg";
export { ForwardRef as ReactComponent };